import script from "./AsideMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AsideMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./AsideMenuItem.vue?vue&type=style&index=0&id=3c3317b7&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3317b7"]])

export default __exports__